import { HttpError } from "react-admin";

import { PP_ADMIN_TOKEN } from "../constants/storageKeys";

export const fetchJson = async (url, options = {}) => {
  const requestHeaders =
    options.headers ||
    new Headers({
      Accept: "application/json",
    });
  if (
    !requestHeaders.has("Content-Type") &&
    !(options && options.body && options.body instanceof FormData)
  ) {
    requestHeaders.set("Content-Type", "application/json");
  }
  requestHeaders.set(
    "Authorization",
    `JWTToken ${localStorage.getItem(PP_ADMIN_TOKEN)}`
  );
  // if (options.user && options.user.authenticated && options.user.token) {

  // }
  const response = await fetch(url, { ...options, headers: requestHeaders });
  const text = await response.text();
  const o = {
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
    body: text,
  };
  const { status } = o;
  const { statusText } = o;
  const { headers } = o;
  const { body } = o;
  let json;
  try {
    json = JSON.parse(body);
  } catch (e) {
    // not json, no big deal
  }
  if (status < 200 || status >= 300) {
    if (status === 404) {
      return Promise.reject(
        new HttpError(
          (json && json.errors && json.errors.internal_error) || statusText,
          status,
          json
        )
      );
    }
    return Promise.reject(
      new HttpError(
        (json && json.error && json.error.message) || statusText,
        status,
        json
      )
    );
  }
  return Promise.resolve({
    status,
    headers,
    body,
    json,
  });
};
